import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const statsForRegister = api(
    (registerId) =>
        registerId &&
        query(
            gql`
                query StatsForRegister($registerId: String!) {
                    statsForRegister(registerId: $registerId) {
                        totalTypes
                        notMapped
                        doNotMap
                        mapped
                        notMappedAssets
                        doNotMapAssets
                        mappedAssets
                    }
                }
            `,
            { registerId },
            { returns: "statsForRegister" }
        )
)
